<div class="fhd-nav-container" *ngIf="isAuthenticated">
    <span class="logo-crop"><img src="{{logoUrl}}" id="logo" alt="FleetHD" /></span>
    <div class="flex-spacer"></div>
    <div *ngIf="headerItems?.length" class="fhd-header-item-container">
        <span *ngFor="let item of headerItems" class="clickable padded-nav-module"
            (click)="toggleClassAlink($event, item)" [ngClass]="{'isActive': isModuleActive(item)}">
            <div [attr.data-id]="item.name.toLowerCase() + 'Module'" style="font-size: 1.12em">
                {{item.name | translate}}</div>
        </span>
    </div>
    <div class="flex-spacer"></div>
    <!--menu for mobile-->
    <span class="header-module-toggle">
        <button mat-icon-button (click)="toggleNavDrawer()">
            <mat-icon>
                menu
            </mat-icon>
        </button>
    </span>
    <!--right-header-items-->
    <div class="fhd-header-profile-container">
        <app-tenant-switcher [tenant]="tenant" [accessibleTenants]="accessibleTenants"
            (switchTenant$)="switchTenant($event)"></app-tenant-switcher>
        <app-notifications></app-notifications>
        <button mat-icon-button *ngIf="thirdPartyApps.length" data-id="linksChain"
            [attr.aria-label]="'@links' | translate" class="header-icon-toggle"
            [ngClass]="{'isActive': linksActive}" [matMenuTriggerFor]="linksMenu">
            <mat-icon>link</mat-icon>
        </button>
        <mat-menu #linksMenu="matMenu">
            <div class="clickable padded-menu-option links-menu-option"
                *ngFor="let app of thirdPartyApps" [attr.data-id]="app.key + 'LinkOption'"
                (click)="launchThirdPartyApp(app)">
                <span>{{ app.labelKey | translate }}</span>
                <small>{{ app.descriptionKey | translate }}</small>
            </div>
        </mat-menu>
        <button mat-icon-button *ngIf="configurationModule" data-id="configurationGear"
            [attr.aria-label]="'Configuration' | translate" class="header-icon-toggle"
            [ngClass]="{'isActive': configurationActive}"
            (click)="toggleClassAlink($event, configurationModule)">
            <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button data-id="profileMenu" class="header-icon-toggle"
            [ngClass]="{'isActive': profileActive}" [matMenuTriggerFor]="menu">
            <mat-icon>person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <div class="icon-with-text clickable padded-menu-option" *ngIf="profileModule"
                (click)="toggleClassAlink($event, profileModule)" type="button">
                <mat-icon>person</mat-icon>
                <span>{{ '@profile' | translate}}</span>
            </div>
            <div class="icon-with-text clickable padded-menu-option" *ngIf="notificationModule"
                (click)="openNotificationPreferences()">
                <mat-icon>notifications</mat-icon>
                <span>{{ '@notificationPreferences' | translate}}</span>
            </div>
            <app-language-picker mode="menu"></app-language-picker>
            <div class="icon-with-text clickable padded-menu-option" data-id="logoutMenuItem" href="#" (click)="logout($event)">
                <mat-icon>logout</mat-icon>
                <span>{{ '@logout' | translate}}</span>
            </div>
        </mat-menu>
    </div>
</div>
<div class="tenant-switch-overlay" *ngIf="tenantSwitching">
    <mat-spinner diameter="48"></mat-spinner>
    <span class="tenant-switch-overlay-label">{{ '@switchingTenant' | translate }}</span>
</div>